import { Box, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import Hub from "./components/Hub";

const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";
const InsightsIcon = `${prefix}/images/icons/insight_icon.svg`;

const Insights = () => {
  const showNotification = (type, message) => {
    enqueueSnackbar(
      JSON.stringify({
        icon: type,
        title: type === "success" ? "Success" : "Error",
        text: message,
      }),
      {
        variant: "custom",
      }
    );
  };
  return (
    <DashboardLayout>
      <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 24px)" }}>
        <DashboardNavbar />
        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
          <Box
            component="img"
            sx={{
              height: 54,
              width: 54,
            }}
            alt="Insights Logo"
            src={InsightsIcon}
          />
          <Stack mt="0.5rem">
            <Typography variant="h4">Insights</Typography>
            <Typography sx={{ lineHeight: "1rem", fontSize: "0.9rem", color: "#666" }}>
              Powered by Alys
            </Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }}>
          <Hub showNotification={showNotification} />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Insights;
